import ApiService from '@/services/apiService';
import listMixin from '../listMixin';
import { mapState, mapGetters } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['tenantName'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicServiceBuildersList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {},
  data: function () {
    return {
      lastSearch: '',
      tableOptions: defaultTableOptions,
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'tenantId',
          align: 'center'
        }, {
          text: this.$i18n_t('Common.tenant'),
          value: 'tenantName',
          align: 'start'
        }, {
          text: 'Service Builder URL',
          value: 'serviceBuilderUrl',
          align: 'start',
          sortable: false
        }, {
          value: 'icon',
          align: 'end',
          sortable: false
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  methods: {
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'tenantName';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const offset = (page - 1) * itemsPerPage;
      ApiService.tenantGetServiceBuilders(offset, itemsPerPage, sortItem, doSortDesc).then(res => {
        this.list = res.data;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching service builders', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    handleClickConsumer(item) {
      if (!window.open(item.serviceBuilderUrl, '_blank')) {
        window.location.href = item.serviceBuilderUrl;
      }
    }
  }
};